import React, { useState, useEffect, useRef } from 'react';
import "../Admin/assete/css/adminheader.css";
import logo_ad from "../Admin/assete/image/LOGO.png";
import { Link, useNavigate } from 'react-router-dom';

const Adminheader = ({ unreadCount }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate(); // you need this to navigate after logout
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleLogout = () => {
    localStorage.removeItem('authenticated');
    localStorage.removeItem('user');
    navigate('/Admin');
}
  return (
    <div className="header_main_div_list">
      <div className="admin_header_main_div">
        <div className="admin_header_div">
          <img src={logo_ad} alt="" />
        </div>
        <div className="icon_group_div">
          {/* Notification Icon */}
          <button className="notification_icon_button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 24c1.104 0 2-.896 2-2H10c0 1.104.896 2 2 2zm6-6v-5c0-2.623-1.678-4.868-4-5.645V6c0-1.657-1.343-3-3-3s-3 1.343-3 3v1.355C7.678 8.132 6 10.377 6 13v5l-2 2v1h16v-1l-2-2zm-2-.828L16 13c0-2.206-1.794-4-4-4s-4 1.794-4 4v4.172L8 18v.828l1.172 1.172h5.656L16 18.828V18z" />
            </svg>
            {unreadCount > 0 && <span className="notification-count">{unreadCount}</span>}
          </button>
        <div className="user_icon_div" ref={dropdownRef}>
          <button className="user_icon_button" onClick={toggleDropdown}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 14V16C8.68629 16 6 18.6863 6 22H4C4 17.5817 7.58172 14 12 14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 21.5L15.0611 23.0451L15.6224 19.7725L13.2447 17.4549L16.5305 16.9775L18 14L19.4695 16.9775L22.7553 17.4549L20.3776 19.7725L20.9389 23.0451L18 21.5Z"></path>
            </svg>
          </button>
          {dropdownOpen && (
            <div className="dropdown_menu">
              <ul>
                <li>
                  <Link to="/Changepassword" onClick={closeDropdown}>
                    Change password
                  </Link>
                </li>
                <li >
              
                   <button onClick={handleLogout} >Logout</button> 
               
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
     </div>
  );
};

export default Adminheader;
